import styled from 'styled-components';
import { Button } from 'antd';

export const StyledButton = styled(Button)`
  margin-bottom: ${({ theme }) => theme.spacing.space_3};
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.space_2};
`;
